/* eslint-disable prefer-template */
import React from 'react';
import {
	BasicButton,
	Radio,
	TextInput
} from '../../UI';
import { getPrimary, getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';
import MenuItemTabs from '../../UI/MenuItemTabs';
import { NO_FORM_SECTIONS } from '../../utils/constants';
import ModalTranslate from './ModalTranslate';
import { getText } from '../../utils/functions';

const PortalRequiredAttachments = ({ portal, translate, updateState }) => {
	const { sections, inputs } = portal.config;
	const tabs = [];
	tabs.push(
		...Object.values(sections || {})
			.filter(sec => !NO_FORM_SECTIONS.includes(sec.value) && sec.isActive)
	);
	const person = 'person';
	const entity = 'entity';
	const representative = 'representative';
	const delegate = 'delegate';
	const people = [
		{
			value: person,
			label: 'Persona física'
		},
		{
			value: entity,
			label: 'Persona jurídica'
		},
		{
			value: representative,
			label: 'Representante'
		},
		{
			value: delegate,
			label: 'Delegado'
		},
	];

	const [localState, setLocalState] = React.useState([]);
	const [localStateMaxSize, setLocalStateMaxSize] = React.useState(portal?.config?.attachmentsMaxSize);
	const [errors, setErrors] = React.useState([]);
	const [errorsMaxSize, setErrorsMaxSize] = React.useState('');
	const [section, setSection] = React.useState(tabs[0].value);

	React.useEffect(() => {
		if (portal.config && portal.config.requiredAttachments) {
			setLocalState(portal.config.requiredAttachments[section]);
		}
	}, [section, portal.config.requiredAttachments]);

	const addAttachment = () => {
		setLocalState([
			...localState,
			{
				name: `requiredAttachment_${localState.length}`,
				label: 'Adjunto',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
				personType: person,
				fileTypes: 'application/pdf, image/png, image/jpeg, image/jpg',
				required: true
			}
		]);
	};

	const deleteAttachment = index => {
		const newArray = [...localState];
		newArray.splice(index, 1);
		setLocalState(newArray);
	};

	const handleUpState = () => {
		if (!errors.length) {
			updateState({
				requiredAttachments: {
					...portal.config.requiredAttachments,
					[section]: localState
				},
				attachmentsMaxSize: parseFloat(localStateMaxSize)
			});
		}
	};

	const changeName = (index, event) => {
		// Save value
		const newArray = [...localState];
		newArray[index] = {
			...newArray[index],
			name: event.target.value,

		};
		setLocalState(newArray);
		// Check errors
		const check = [];
		const names = newArray.map(att => att.name);
		names.forEach((item, idx) => {
			if (names.indexOf(item) !== idx) {
				check[idx] = 'Nombre duplicado';
			}
		});
		setErrors([...check]);
	};

	const changeFileTypes = (index, event) => {
		// Save value
		const newArray = [...localState];
		newArray[index] = {
			...newArray[index],
			fileTypes: event.target.value,

		};
		setLocalState(newArray);
	};

	const changeMaxSize = event => {
		// Save value
		setLocalStateMaxSize(event.target.value);
		// Check errors
		if (event.target.value < 100) {
			setErrorsMaxSize('Valor no válido');
		}
		setErrorsMaxSize('');
	};

	const getFilteredPersonOptions = React.useMemo(() => people
		.filter(
			personFilter => personFilter.value === 'person'
				// Entity and personOrEntity is active
				|| (
					personFilter.value === 'entity'
					&& inputs[section].person.find(inp => inp.name === 'personOrEntity')?.isActive
				)
				// Representative and representation or optional representation
				|| (
					personFilter.value === 'representative'
					&& (
						section === 'representation'
						|| portal.config?.optionalFields[section].representation === true
						|| (section === 'access' && inputs[section].person.find(inp => inp.name === 'personOrEntity')?.isActive)
					)
				)
				// Delegate and delegation or optional delegation
				|| (
					personFilter.value === 'delegate'
					&& (
						section === 'delegation'
						|| portal.config?.optionalFields[section].delegation === true
					)
				)
		), [inputs, section]);

	const renderForm = () => (
		<div>
			<MenuItemTabs
				items={tabs}
				translate={translate}
				setSelected={setSection}
				selected={section}
				colorSelected={'#000000'}
			/>
			<div
				style={{
					display: 'flex',
					width: '100%',
					justifyContent: 'space-between',
				}}
			>
				<BasicButton
					text={translate.add}
					onClick={addAttachment}
				/>
				<TextInput
					styles={{ color: 'black', width: '30%' }}
					floatingText={'Tamaño máximo total de los Adjuntos (KB)'}
					type="number"
					value={localStateMaxSize}
					errorText={errorsMaxSize}
					onChange={changeMaxSize}
				/>
			</div>
			<div style={{
				paddingTop: '1rem',
				paddingBottom: '1rem',
			}}>
				{localState?.map((attachment, index) => (
					<div key={'item_' + index} style={{
						padding: '1em',
						border: '1px solid ' + getSecondary(),
						display: 'flex',
						flexDirection: 'column',
						borderRadius: '3px',
						marginBottom: '.5em',
						justifyContent: 'space-between',
						gap: '1rem',
						alignItems: 'center'
					}}>
						<div style={{
							display: 'flex',
							width: '100%',
							justifyContent: 'space-between',
							justifyItems: 'center'
						}}>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<label style={{ fontSize: '0.75rem', color: getSecondary() }}>
									Nombre del Adjunto
								</label>
								<span>
									{getText(attachment, translate)}
								</span>
							</div>
							<ModalTranslate
								translate={translate}
								item={attachment}
								name={getText(attachment, translate)}
								setLocalState={newData => {
									const newArray = [...localState];
									newArray[index] = {
										...newArray[index],
										...newData,

									};
									setLocalState(newArray);
								}}
							/>
							<TextInput
								styles={{ color: 'black', width: '25%' }}
								floatingText={'Tipos de archivo admitidos'}
								type="text"
								value={attachment.fileTypes}
								onChange={event => changeFileTypes(index, event)}
							/>
							<button
								style={{
									border: '1px solid ' + getSecondary(),
									borderRadius: '4px',
									padding: '.5rem',
									background: localState[index]?.required ? getPrimary() : 'transparent',
									cursor: 'pointer',
									marginRight: '.4rem',
									color: localState[index]?.required ? 'white' : getSecondary(),
								}}
								onClick={() => {
									const newArray = [...localState];
									newArray[index] = {
										...newArray[index],
										required: !localState[index]?.required
									};
									setLocalState(newArray);
								}}
							>
								Requerido
							</button>
							<div
								style={{
									cursor: 'pointer',
									fontSize: '1.25rem',
									color: 'red',
								}}
								onClick={() => deleteAttachment(index)}
							>
								X
							</div>
						</div>
						<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
							<TextInput
								styles={{ color: 'black', width: '33%' }}
								floatingText={'Nombre del archivo (Para el admin de la junta)'}
								type="text"
								value={attachment.name}
								errorText={errors && errors[index]}
								onChange={event => changeName(index, event)}
							/>
							<div style={{
								display: 'flex', flexDirection: 'column', width: '60%',
							}}>
								<label style={{ fontSize: '0.75rem', color: getSecondary() }}>
									Tipo de persona
								</label>
								<div style={{
									display: 'flex', width: '100%', gap: '1rem',
								}}>
									{getFilteredPersonOptions.map(personType => (
										<Radio
											key={personType.value}
											styleLabel={{ margin: '0' }}
											name="entities"
											label={getText(personType, translate)}
											value={personType.value}
											checked={attachment.personType === personType.value}
											onChange={() => {
												const newArray = [...localState];
												newArray[index] = {
													...newArray[index],
													personType: personType.value
												};
												setLocalState(newArray);
											}}
										/>
									))}
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);


	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={handleUpState}
					disabled={errors.length > 0}
					backgroundColor={{
						backgroundColor: errors.length > 0 ?
							'#F0F0F0' : getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

export default PortalRequiredAttachments;
